import * as R from 'ramda';

export const memoCallback = (prevProps, nextProps, omitItems, simpleCompare = false) => {
  if (simpleCompare) {
    return R.equals(prevProps, nextProps);
  }
  if (nextProps.isOpen || prevProps.isOpen) {
    return false;
  } else if (!R.equals(R.omit(omitItems, prevProps), R.omit(omitItems, nextProps))) {
    return false;
  } return true;
};



// WEBPACK FOOTER //
// ./src/utils/memo-callback.js